<template>
  <v-container fluid>
    <v-dialog 
      v-model = "createBroadcastDialog" 
      width="500">
      <v-card>
        <v-card-title
          class="headline"
          primary-title>
          {{ selected && selected.length && selected.length === 1 ? 'Rename Broadcast' : 'Create New Broadcast' }}
        </v-card-title>
        <v-card-text>
          <add-broadcast
            ref = "addBroadcast"
            :put = "selected && selected.length && selected.length === 1 ? selected[0] : null"
            @loading = "addButtonLoader = $event"
            @success = "createBroadcastDialog = false">
              <label slot = "before-name">Broadcast Name</label>
              <label slot = "before-channel">Broadcast Channel</label>
              <label slot = "before-app">Broadcast App</label>
          </add-broadcast>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            outline
            @click="createBroadcastDialog = false">
            Cancel
          </v-btn>
          <v-btn
            :loading = "addButtonLoader"
            color="primary"
            @click="addNewBroadcast">
            {{ selected && selected.length && selected.length === 1 ? 'Rename' : 'Create' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog 
      v-model = "deleteBroadcastDialog" 
      width="400">
      <v-card v-if = "selected && selected.length">
        <v-card-title
          class="headline"
          primary-title>
          Delete {{ selected.map(broadcast => broadcast.name).join(', ') }}
        </v-card-title>
        <v-card-text>
          Are you sure you want to delete this Broadcast?
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            :loading = "addButtonLoader"
            color="error"
            outline
            @click="deleteBroadcasts">
            Delete
          </v-btn>
          <v-btn
            color = "black"
            class = "white--text"
            @click="deleteBroadcastDialog = false">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout 
      row 
      wrap>
      <h1>My Broadcasts</h1>
      <v-spacer />
    </v-layout>
    <v-flex xs12>
    </v-flex>
    <v-flex xs12>
      <v-card class = "card-curvey">
        <v-layout 
          row 
          wrap>
          <v-flex xs4>
            <v-text-field
              v-model = "queries.q"
              placeholder = "Search By Name, Type or Culture"
              broadcastend-icon = "search"
              outline />
          </v-flex>
          <v-spacer />
          <v-btn
            :disabled = "!selected || !selected.length || selected.length !== 1"
            :loading = "!!(addButtonLoader && selected.length)"
            color = "blue-grey"
            class = "nlp-nav-btn"
            small
            outline
            @click = "openAddDialog(false)">
            <v-icon>edit</v-icon>
            Rename
          </v-btn>
          <v-btn
            :disabled = "!selected || !selected.length || selected.length !== 1"
            color = "blue-grey"
            class = "nlp-nav-btn"
            small
            outline
            @click = "deleteBroadcastDialog = true">
            <span 
              class="botter-trash-icon" 
              style="padding-right: 6px"/>
            Delete
          </v-btn>
          <v-btn
            :loading = "!!(addButtonLoader && !selected.length)"
            color = "blue-grey"
            class = "nlp-nav-btn"
            small
            outline
            @click = "openAddDialog(true)">
            <v-icon>add</v-icon>
            New Broadcast
          </v-btn>

        </v-layout>
        <v-flex xs12>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="queriedBroadcasts"
            item-key="name"
            no-data-text = "No Broadcasts Available"
            select-all
            class="elevation-1 nlp-data-table">
            <template 
              slot="items" 
              slot-scope = "props" > 
              <tr 
                v-if = "props.index === 0 && !props.item.name" 
                class = "text-center" 
                style="width: 100%">
                <td /><td /><td /><td class="text-center">No Broadcasts Available</td><td /><td />
              </tr>
              <tr v-if = "props.item.name">
                <td>
                  <v-checkbox
                    v-model="props.selected"
                    primary
                    hide-details
                  />
                </td>
                <td>
                  <span
                    class = "primary--text pointer-cursor"
                    @click = "selectBroadcast(props.item)">
                    {{ props.item.name }}
                  </span>
                </td>
                <td class="text-center">
                  <supported-platforms
                    :manual-channels = "[ props.item.app.provider ]"
                    :placeholder = "null"
                    class="mt-3"/>
                </td>
                <td class="text-center">{{ props.item.count }}</td>
                <td class="text-center">{{ props.item.status }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-card>
    </v-flex>
        </v-layout>
  </v-container>
</template>

<script>
import AddBroadcast from '../components/broadcasts/AddBroadcast.vue'
import SupportedPlatforms from '../components/block-build/blocks/SupportedPlatforms.vue'
export default {
  name: 'BroadcastList',
  components: {
    AddBroadcast,
    SupportedPlatforms
  },
  data() {
    return {
      queries: {
        q: ''
      },
      createBroadcastDialog: false,
      deleteBroadcastDialog: false,
      addButtonLoader: false,
      selected: [],
      headers: [
        {
          text: 'Broadcast Name',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        { text: 'Channel', value: 'app', align: 'center' },
        { text: 'Number Of Recievers', value: 'count', align: 'center' },
        { text: 'Status', value: 'status', align: 'center' }
        // { text: '', value: 'actions' }
      ]
    }
  },
  computed: {
    queriedBroadcasts() {
      return this.$store.getters['broadcasts/query'](this.queries.q)
    }
  },
  watch: {
    selected: {
      deep: true,
      handler(val) {
        if(val && val.length && val.length > 1) {
          this.selected = [val[val.length - 1]]
        }
      }
    }
  },
  mounted() {
    // get broadcasts
    this.getBroadcasts()
  },
  methods: {
    getBroadcasts() {
      this.$store.dispatch('broadcasts/get', null).catch(err => {
        this.$store.dispatch('setErrorMessage', true)
      })
    },
    openAddDialog(reset = true) {
      if(reset)
        this.selected = []
      this.createBroadcastDialog = true
    },
    addNewBroadcast() {
      if (this.$refs.addBroadcast) this.$refs.addBroadcast.submit()
    },
    selectBroadcast(broadcast) {
      this.$store.dispatch('broadcasts/select', broadcast)
      if (this.$route.query.from) {
        this.$router.push({ name: this.$route.query.from, params: { id: broadcast._id } })
      } else {
        this.$router.push(`/broadcasts/${broadcast._id}`)
      }
    },
    deleteBroadcasts() {
      this.$store.dispatch('setLoader', true)
      this.$store
        .dispatch('broadcasts/delete/single', this.selected[0]._id)
        .then(() => {
          this.$store.dispatch('setSnackbar', {
            text: `Deleted Successfully`,
            color: 'success'
          })
          this.selected = []
          this.$store.dispatch('setLoader', false)
        })
        .catch((err) => {
          // console.log(err)
          this.$store.dispatch('setErrorMessage', true)
          this.$store.dispatch('setLoader', false)
        })
    }
  }
}
</script>

<style lang="scss" src="../assets/sass/commponents/nlp.scss">
</style>
